import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { styled } from '@mui/system'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import AddVendors from './AddVendors';
import Typography from '@mui/material/Typography';
import Columnsettings from './Columnsettings';
import Checkbox from '@mui/material/Checkbox'; 
import Tooltip from '@mui/material/Tooltip';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import EmailTwoToneIcon  from '@mui/icons-material/EmailTwoTone';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ReactToPrint from 'react-to-print';
import SettingsIcon from '@mui/icons-material/Settings';
function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: '1 1 100%',
  },
}));
const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  };
EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
export default class AdminVendors extends Component {
    constructor(props) {
    super(props);
      this.state = {redirect: false,iconslist:false,allchecked:false,
      veid:'',ve_id:'',page: 0,pagename:'', prevpage:0,totaldata:0,rowsPerPage:50,vendordata:[],
	  order:'desc' ,orderBy:'',titles:'',countrydata:[],countrylabel:'Select Country',Checkbox:0,ColumnData:[],veides:'',vendorcopy:1,totalrecords:0,selectedcount:0,
      }
       this.updatevendorParent = this.updatevendorParent;
	}
	updatevendorParent = (text) => {this.apicall(this.state.page,this.state.rowsPerPage);
	this.updateColumnssetting=this.updateColumnssetting;  
	}
	updateColumnssetting = (text) => 
	{
        this.ColumheadervendosApi();
	}
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,vendordata:[]
    });
}
ColumheadervendosApi(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid='+localStorage.getItem("ISIuserid")+'&cc_page=10&cc_isdisplay=1')
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  ColumnData: resp.data,  
			  colcount:parseInt(resp.data[0].count),
			});
     }
	  else{
		   axios.get(localStorage.getItem("ISIurl")+'ajaxcolumnconfigure.php?action=getall&cc_userid=0&cc_page=10&cc_isdisplay=1')
  .then(resp => {  	
				if(resp.data.length>0){
						this.setState({  
						  ColumnData: resp.data,  
						   colcount:parseInt(resp.data[0].count),
						});
				 }
	     });
	 }
    });
}
	componentWillMount() {
	document.title = "Vendors Details";
	if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
		   this.apicall(this.state.page,this.state.rowsPerPage);	
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
		 this.props.parentdasCallback(
            "Vendors~"
        );
	  localStorage.setItem("page",this.state.rowsPerPage)
} 
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=5')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
        this.apicall(this.state.page,this.state.rowsPerPage);
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}
handleClickSearch=()=>{   
  this.apicall(this.state.page,this.state.rowsPerPage); 
} 
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 }
apicall(page,rowsPerPage){
	 axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=getall&ve_cmp_id='+localStorage.getItem("ISIcmpid")+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&ve_businessname='+this.state.titles)
  .then(resp => {  
    if(resp.data.length>0){
			this.setState({  
			  vendordata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   totalrecords:parseInt(resp.data[0].count),
		    });
			let copy=[50, 100, 150, 200, 250]	;
	  this.setState({rowsPaging:copy});
     }
	 else{
		   this.setState({vendordata:[],totaldata:0});
	 }
  this.ColumheadervendosApi();
    });
}
handleChangePage = (event, newPage) => {  
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    },()=>{this.apicall(this.state.page,this.state.rowsPerPage)});
  }; 
   handleChangeRowsPerPage = event => {  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
  }; 
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
  });
};
      VendorsDelete(veid){  
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ 
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('ve_id',veid)
	  formData.append('userid',localStorage.getItem("ISIuserid"))	   
	 axios.post(localStorage.getItem("ISIurl")+"ajaxvendors.php", formData, {
        }).then(res => {
    this.apicall(this.state.page,this.state.rowsPerPage); 
            });
 }
      }
  HandleAllcheckbox=()=>{
        var studArray = this.state.vendordata;
        var subnewRow="";
        this.setState({allchecked:!this.state.allchecked},() => {
        if(this.state.allchecked===false)
                 {
                  studArray.map((rowssub,j) => {
                  rowssub.isseleceted = "0" ;
                                 });
                 }
				 else if(this.state.allchecked===true)
                         {
                            studArray.map((rowssub, j) => {
                              rowssub.isseleceted = "1" ;
                           });
						 }
				this.setState({vendordata:studArray},()=>{
				const selectedItems= this.state.vendordata.filter(item => item.isseleceted==="1")
                this.setState({selectedcount:selectedItems.length});
                const selectedIds = selectedItems.map(item => item.ve_id);
                const selectedIdsString = selectedIds.join(',');
                  this.setState({veides:selectedIdsString},()=>{
                        if(this.state.veides!=="")
                          {
						  this.setState({iconslist:true});
                          }
                          else
                          {
                             this.setState({iconslist:false});
                          }   
                  if (selectedIds.length >= 2) 
				        {
                         this.setState({disablecopyicon: false,});
                        } 
                    else{
                         this.setState({disablecopyicon:true });
                        }
                  });
           });
      }); 
  } 
  HandleCheckbox=(id,rowsd)=>{
 const updatedArray=[...this.state.vendordata];
          if(updatedArray[rowsd].isseleceted==="0")
          {
                  updatedArray[rowsd].isseleceted = "1" ;
          }
		  else
          {
          updatedArray[rowsd].isseleceted = "0" ;
          }
        this.setState({vendordata:updatedArray,},()=>{
        const selectedItems= this.state.vendordata.filter(item => item.isseleceted==="1")
		this.setState({selectedcount:selectedItems.length});
                  const selectedIds = selectedItems.map(item => item.ve_id);
                  const selectedIdsString = selectedIds.join(',');
                  this.setState({veides:selectedIdsString},()=>{
                          if(this.state.veides!=="")
                          {
                         this.setState({iconslist:true});
                          }
                          else
                          {
                              this.setState({iconslist:false});
                          }
                    });
                 if (selectedItems.length >= 2) {
         this.setState({disablecopyicon: false });
         } 
                   else{
                         this.setState({disablecopyicon: true });
                       }
          }) ;
  }
  onClickBulkdelete(){
	const idsArray = this.state.veides.split(",").filter(id=>id.trim() !==""); 
     let r = window.confirm("Do you really want to Delete?");
		 if(r == true){
			  var formData = new FormData(); 
					 formData.append('action','delete')	
					 formData.append('ve_id',this.state.veides)
			         formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxvendors.php", formData, {
						}).then(res =>{
							  this.apicall(this.state.page,this.state.rowsPerPage); 
						});
		 }
  }
  OnSelectSendEmail()
  {
	    var formData = new FormData(); 
		formData.append('action','sendemail')	
		formData.append('ve_id',this.state.veides)
		formData.append('ve_cmp_id',localStorage.getItem("ISIcmpid"))
		axios.post(localStorage.getItem("ISIurl")+"ajaxvendors.php", formData, {
		}).then(res =>{
						 this.apicall(this.state.page,this.state.rowsPerPage); 
					  });
   }
  Vendoraddbox(val,val2){
        this.setState({ ve_id: val,vendorcopy:val2 },()=>{});  
         setTimeout(() => this.refs.AddVendors.handlevendorClickOpen(),500);
      }
 addcheckbox(){
     setTimeout(() => this.refs.Columnsettings.handleClickOpen(),500);
       }
	     addprintbox(){
    setTimeout(() => this.refs.PrintBox.handleClickOpen(),500);
    }
ActiveInActiveSatusUpdate(cuid,activestatus){ 
let r = window.confirm("Do you really want to Inactive?");
 if(r === true){
 var formData = new FormData();
     formData.append('action','ActiveStatus')
	 formData.append('strid',cuid)
	 formData.append('activestatus',activestatus)
	 formData.append('strpage',2)
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
        }).then(res => {
            this.apicall(this.state.page,this.state.rowsPerPage);
            });
 }
   }
render() {
if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
 const { children, value, index, ...other } = this.props;
  return (
<React.Fragment>
<div className="searchbox">
 <ul>
 <li><TextField
  className="txtbox"
  value={this.state.selectedcount + " of " + this.state.totalrecords + " selected"}
  readOnly
/>
</li>
 <li>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.titles}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Search"
			className="txtbox"
            name="titles" onChange={this.myChangeHandler}
          /></p></li>
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmthirdbtn" endIcon={<SearchIcon />}>
        Search
      </Button>
	 &nbsp;&nbsp;&nbsp;&nbsp;
   <Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Vendoraddbox(0)}} endIcon={<AddIcon />}>New</Button>
  </p>
  </li>
</ul>
</div>	
<div className="clear"></div>		
<Columnsettings 
ref="Columnsettings"  
pageval={10}
updateDonenew={this.updateColumnssetting}
/>
<PrintBox ref="PrintBox" childcols={this.state.ColumnData} veides={this.state.veides}/>
<AddVendors ref="AddVendors" id={this.state.ve_id}  
updatevendor={this.updatevendorParent}/>	
{this.state.iconslist===true && (
<div className="iconlistprint">
<p>
<Tooltip title="Print" placement="top">
  <IconButton>
  <LocalPrintshopIcon onClick={()=>{this.refs.PrintBox.handleClickPrint()}}/>
  </IconButton>
</Tooltip>
<Tooltip title="Email" placement="top">
  <IconButton>
   <EmailTwoToneIcon  onClick={()=>{this.OnSelectSendEmail()}}/>
  </IconButton>
</Tooltip>
{this.state.disablecopyicon === true && (
    <Tooltip title="Copy" placement="top">
      <IconButton>
        <ContentCopyTwoToneIcon  onClick={()=>{this.Vendoraddbox(this.state.veides)}} />
      </IconButton>
    </Tooltip>
)}
<Tooltip title="Delete" placement="top">
  <IconButton>
 <DeleteIcon onClick={()=>{this.onClickBulkdelete()}} />
  </IconButton>
</Tooltip>
</p>
</div>	
)}
<div onClick={this.handleOpen} className="ui-conatiner">
       <span className="congiguration" onClick={()=>{this.addcheckbox()}}>   <SettingsIcon /> </span>
        </div>
<Paper className={useStyles.root}>
<div  className="tablecontainers">
  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
	  {this.state.totaldata!==0 && (
            <TableCell>   
			<Checkbox 
           checked={this.state.allchecked}
           onChange={()=>{this.HandleAllcheckbox()}}
            inputProps={{ 'aria-label': 'controlled' }}
            sx={{
          color: 'white', 
         '&.Mui-checked': {
            color: 'white', 
        },
    }}
              /> 	
			</TableCell>
		  )}
 			{this.state.ColumnData.map((col,i) => {  
           return ( 
		    <TableCell>
			{col.cc_displayname}
			 </TableCell>
		      )
		 })}    <TableCell>
			   </TableCell>                                    
</TableRow></TableHead>
 <TableBody>
          {this.state.vendordata.map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >
 <TableCell>{item.isseleceted==="0" && (
        <Checkbox
         onChange={()=>{this.HandleCheckbox(item.ve_id,index)}}
         inputProps={{ 'aria-label': 'controlled' }}
		      sx={{'&.Mui-checked': {
            color: 'gray', 
                },
                }}
        /> 
      )}{item.isseleceted==="1" && (
        <Checkbox
      checked
      onChange={()=>{this.HandleCheckbox(item.ve_id,index)}}
	       sx={{ '&.Mui-checked': {
            color: 'gray', 
            },
          }}
     /> 
     )}</TableCell>
{this.state.ColumnData.map((cols,i) => { 
	let colsname	=  cols.cc_columnname; 
	return ( <React.Fragment>
	<TableCell><span> <a className="link" href={"#/Vendorviewmore?veid="+item.ve_id+""}>{item[""+colsname+""]}</a></span></TableCell>
			</React.Fragment>	);
					})}
<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="frmSecondarybtn"  onClick={()=>{this.Vendoraddbox(item.ve_id)} }endIcon={<EditIcon />}>
Edit
</Button>
&nbsp;&nbsp;
{( <React.Fragment>	
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.VendorsDelete(item.ve_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>
&nbsp;&nbsp;
{item.ve_isactive === "1" && (
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.ActiveInActiveSatusUpdate(item.ve_id,0)}} >
   Active
</Button>
)}
{item.ve_isactive === "0" && (
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.ActiveInActiveSatusUpdate(item.ve_id,1)}} >
  In Active
</Button>
)}
</React.Fragment>
)}
 </div>
 </TableCell>
 </TableRow>
 </React.Fragment>	
);
					})}
					{this.state.totaldata===0 &&(
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
                      </TableBody>
</Table>
  </TableContainer> 
  </div>
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage} 
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
 </React.Fragment> 
  );
}
}	
/*print box*/
export class PrintBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printopen: false,
	  VendorArray:[],
    };
  }
 handleClickPrint = () => {
this.GetVendorBYIdes(this.props.veides)
};
 GetVendorBYIdes(id){
axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=getall&ve_id='+id)
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  VendorArray: resp.data,  
			},()=>{
				 setTimeout(() =>
document.getElementById('print-button').click() 
,500);
			});
     }
	  else{
		   this.setState({VendorArray:[]});
	 }
    });
}
  render() {
 return (
	 <React.Fragment>
	 <div className="printmod">
	<div ref={el => (this.componentRef = el)} >
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
		   {this.props.childcols.map((cols,i) => {  
           return (
		    <TableCell>{cols.cc_displayname}</TableCell>
		   )
		  })}
          </TableRow>
        </TableHead>
  <TableBody>
{this.state.VendorArray.map((item,index) => {  
           return ( 
 <TableRow key={index} >
{this.props.childcols.map((cols,i) => { 
	  let colsname	=  cols.cc_columnname; 
	  return ( <React.Fragment>
<TableCell>{item[""+colsname+""]}</TableCell>
			</React.Fragment>	);
					})}
 </TableRow>
	);	})}
 </TableBody>
</Table>
  </TableContainer> 
  </Paper>
</div>
<ReactToPrint 
            trigger={() => <p id="print-button" className="Primarybuttons">Print </p>}
			content={() =>  this.componentRef} />
		</div>	
			 </React.Fragment>
 ); 
 }
}